import { isNil } from 'lodash';
import { useCallback, useState } from 'react';
import { MBHeaderButton } from '@shared/components/button';
import { MBModalOrMobile } from '@shared/components/modalOrMobile';
import { useResponsiveFormContext } from '@shared/scenes/entity/components/ResponsiveFormContext';
import { MBWorkflowCreate } from '@shared/scenes/workflows/create/container';
import { WorkspaceDetail } from '@shared/scenes/workflows/hooks';
import { PAGE_MODAL_WIDTH } from '@shared/styles';
import { useFunctionState } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { SubformRoute, useNavStackContext } from '@shared/util/navigation';

export function WorkflowCreate({
  channelSlug,
  originWorkflowTemplateId,
  originSubformComponentId,
  workspaceDetails,
}: {
  channelSlug: string;
  originWorkflowTemplateId: string;
  originSubformComponentId: string;
  workspaceDetails: Map<string, WorkspaceDetail>;
}) {
  const nav = useNavStackContext<SubformRoute>();
  const isResponsiveForms = useResponsiveFormContext();

  const [dirty, setDirty] = useState(false);
  const [loading, setLoading] = useState(false);
  const [onSubmit, setOnSubmit] = useFunctionState();

  const onSave = useCallback(async () => {
    setLoading(true);
    try {
      if (!isNil(onSubmit)) {
        await onSubmit();
      }
    } finally {
      setLoading(false);
    }
  }, [onSubmit]);

  const webOverlayStyle = {
    backgroundColor: 'transparent',
  };

  return (
    <MBModalOrMobile
      desktopModalWidth={PAGE_MODAL_WIDTH}
      desktopModalHeight={'calc(95vh - 76px)' /* height of bottom button */}
      title={i18n('workflowTemplate.customizeFields')}
      onBack={nav.pop}
      paddingOnWeb={0}
      desktopModalRightButton={
        dirty && <MBHeaderButton title={i18n('common.save')} onPress={onSave} loading={loading} />
      }
      webOverlayStyle={isResponsiveForms ? undefined : webOverlayStyle}
    >
      <MBWorkflowCreate
        channelSlug={channelSlug}
        onDirty={setDirty}
        onSubmitFormButtonCallback={setOnSubmit}
        name={i18n('workflowTemplate.subformOptions.newSubform')}
        workflowTemplateId={originWorkflowTemplateId}
        subformComponentId={originSubformComponentId}
        workspaceDetails={workspaceDetails}
        goBackOverride={nav.pop}
      />
    </MBModalOrMobile>
  );
}
